import React from "react";
import PropTypes from "prop-types";

// import router link
import { Link } from "react-router-dom";

// import moment
import moment from "moment";
import "moment/locale/fr";

// import common components
import Lister from "../../common/Lister";

// import utilities
import {
  calculateCol,
  getObjectByKey,
  slugify,
} from "../../../helpers/utilities";

// import dummies
import { COUNTRY, OPPORTUNITY } from "../../../helpers/dummies";

// import constants
import { ITEMS_TO_DISPLAY_XS } from "../../../helpers/constants";

const ListArticle = ({
  items,
  itemsPerRow,
  listerClasses,
  withDiscover,
  withPagination,
}) => {
  return (
    <React.Fragment>
      <Lister
        listerClasses={`${listerClasses} articles opportunities`}
        withPagination={withPagination}
        withDiscover={withDiscover}
        discoverOptions={{ discoverLink: "#" }}
      >
        {items &&
          items.map((item, index) => {
            let itemArticle = {
              ...item,
              views: item.views ? item.views : 0,
              category: item.category ? item.category : "Article",
              image: item.image ? item.image : OPPORTUNITY.image,
              title: item.name ? item.name : "Lorem ipsum",
            };
            return (
              <ArticleItem
                key={`bourse_item_${index}`}
                col={calculateCol(itemsPerRow)}
                {...itemArticle}
              />
            );
          })}
      </Lister>
    </React.Fragment>
  );
};
ListArticle.propTypes = {
  items: PropTypes.array,
  itemsPerRow: PropTypes.number,
  listerClasses: PropTypes.string,
  withPagination: PropTypes.bool,
};
ListArticle.defaultProps = {
  itemsPerRow: ITEMS_TO_DISPLAY_XS,
  listerClasses: "g-3 mt-5",
  withDiscover: false,
  withPagination: false,
};
export default ListArticle;

/**
 * Article item.
 */
const ArticleItem = ({
  col,
  views,
  category,
  image,
  publicId,
  createdAt,
  title,
  description,
}) => (
  <div className={`col-lg-${col} col-md-6 col-sm-12`}>
    <article className="box">
      <div className="box-image">
        <img src={image} alt="" className="img-fluid" />
      </div>

      <h2 className="box-title">
        <Link
          to={{
            pathname: `/articles/${slugify(title)}`,
            state: { code: publicId, name: title },
          }}
        >
          {title.length > 20 ? title.substr(0, 19) + "..." : title}
        </Link>
      </h2>

      <div className="box-content">
        <div>
          <p className="post-title">
            {description.length > 80
              ? description.substr(0, 79) + "..."
              : description}
          </p>

          <span className="post-meta">
            <span className="post-category">{category},</span>
            <span className="post-views ms-2">
              {views} {`${views > 1 ? "vues" : "vue"}`}
            </span>
          </span>
        </div>
        <div className="d-flex align-items-center justify-content-between mt-4">
          <div className="read-more">
            <Link
              to={{
                pathname: `/articles/${slugify(title)}`,
                state: { code: publicId, name: title },
              }}
            >
              Lire plus
            </Link>
          </div>
        </div>
      </div>
    </article>
  </div>
);
